import { useEffect, useState } from 'react'

export const useRedirectFromLegacyApp = () => {
  const [showRedirectMessage, setShowRedirectMessage] = useState<boolean>(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const hasSource = searchParams.has('source')

    if (hasSource) {
      const sourceValue = searchParams.get('source')

      if (sourceValue === 'legacy-app-redirect') {
        setShowRedirectMessage(true)
      }
    }
  }, [])

  return showRedirectMessage
}
